import {
  Box,
  Text,
  Input,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import React, { useEffect, useState } from "react";
import { api } from "../../services/api";
import { useLocation } from 'react-router-dom';
import { BeerFilters } from "../BeerFilters";
import { WineFilters } from "../WineFilters";
import { KitFilters } from "../KitFilters";
import { HardDrinkFilters } from "../HardDrinkFilters";
import { OtherDrinksFilters } from "../OtherDrinksFilters";
import { SubcategoryFilters } from "../SubcategoryFilters";
import { ChoppFilters } from "../ChoppFilters";


export function Filters({urlParams, setProducts, products }) {
  const location = useLocation();
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [activeButton, setActiveButton] = useState('');

  const handleMinPriceChange = (event) => {
    setMinPrice(event.target.value);
  };

  const handleMaxPriceChange = (event) => {
    setMaxPrice(event.target.value);
  };

  const fetchProducts = async (params) => {
    let apiUrl = '/api/v1/products';
    const { minPrice, maxPrice, brands, types, order } = params;

    const queryParams = new URLSearchParams();

    if (minPrice) queryParams.append("minPrice", minPrice);
    if (maxPrice) queryParams.append("maxPrice", maxPrice);
    if (brands.length) queryParams.append("beer_brands", brands.join(','));
    if (types.length) queryParams.append("beer_types", types.join(','));

    const filterParam = urlParams.get("filter");
    if (filterParam) queryParams.append("filter", filterParam);
    const brandParam = urlParams.get("brand");
    if (brandParam) queryParams.append("brand", filterParam);
    const query = urlParams.get("query");
    if (query) queryParams.append("query", query);
    if (order) queryParams.append("order", order);

    console.log(queryParams.toString());

    try {
      const response = await api.get(`${apiUrl}?${queryParams.toString()}`);
      setProducts(response.data.products);
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Smooth scrolling animation
      });
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: '' });
  }, [minPrice, maxPrice]);

  const sortBestSelling = () => {
    // Toggle between active and deselected state
    if (activeButton === 'best_selling') {
      setActiveButton(''); // Deselect
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: '' }); // Fetch original products
    } else {
      setActiveButton('best_selling'); // Select "best_selling"
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: 'best_selling' });
    }
  };

  const sortBiggestDiscounts = () => {
    if (activeButton === 'biggest_discounts') {
      setActiveButton(''); // Deselect
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: '' }); // Fetch original products
    } else {
      setActiveButton('biggest_discounts'); // Select "biggest_discounts"
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: 'biggest_discounts' });
    }
  };

  const sortLowestPrices = () => {
    if (activeButton === 'lowest_prices') {
      setActiveButton(''); // Deselect
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: '' }); // Fetch original products
    } else {
      setActiveButton('lowest_prices'); // Select "lowest_prices"
      fetchProducts({ minPrice, maxPrice, brands: [], types: [], order: 'lowest_prices' });
    }
  };

  const handleFilterToDisplay = () => {
    const filterParam = urlParams.get('filter');
    if (filterParam) {
      try {
        const filterArray = JSON.parse(filterParam);
        if (Array.isArray(filterArray)) {
          if  (filterArray.includes("CERVEJA") || filterArray.includes("Microcervejarias")) {
            return <BeerFilters setProducts={setProducts} />;
          } else if (filterArray.includes("Vinho")) {
            return <WineFilters setProducts={setProducts} />;
          } else if (filterArray.includes("DESTILADOS")) {
            return <HardDrinkFilters setProducts={setProducts} />;
          } else if (filterArray.includes("OUTRAS BEBIDAS")) {
            return <OtherDrinksFilters setProducts={setProducts} />;
          } else if (filterArray.includes("Maiores Descontos") || filterArray.includes("Mais Vendidos") || filterArray.includes("Bebidas") || filterArray.includes("Novidades")) {
            return <SubcategoryFilters setProducts={setProducts} />;
          } else if (filterArray.includes("Kits")) {
            return <KitFilters setProducts={setProducts} />;
          } else if (filterArray.includes("Chopp")) {
            return <ChoppFilters setProducts={setProducts} />;
          }
        }
      } catch (error) {
        console.log('Not an array');
      }
    } else {
      return <SubcategoryFilters setProducts={setProducts} />;
    }
  };

  const SortButton = ({ label, isActive, onClick }) => (
    <Box
      as="button"
      onClick={onClick}
      h="42px"
      w="100%"
      px="16px"
      borderRadius="12px"
      border={isActive ? "1.5px solid #004a33" : "1.5px solid rgba(0,74,51,0.15)"}
      bg={isActive ? "#004a33" : "white"}
      color={isActive ? "#fc8f04" : "#004a33"}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      fontSize="13px"
      fontWeight="700"
      cursor="pointer"
      transition="all 0.15s"
      _hover={{
        borderColor: "#004a33",
        bg: isActive ? "#006644" : "rgba(0,74,51,0.04)",
        transform: "translateY(-1px)",
      }}
      _active={{ transform: "scale(0.98)" }}
    >
      <span>{label}</span>
      {isActive && <Box as="span" fontSize="12px" fontWeight="900">✓</Box>}
    </Box>
  );

  const SectionLabel = ({ children }) => (
    <Text
      fontSize="11px"
      fontWeight="800"
      color="rgba(0,74,51,0.55)"
      letterSpacing="0.08em"
      textTransform="uppercase"
      mb="10px"
    >
      {children}
    </Text>
  );

  const renderFiltersContent = () => (
    <>
      <SectionLabel>Ordenação</SectionLabel>
      <Box display="flex" flexDirection="column" gap="8px" mb="24px">
        <SortButton label="Mais Vendidos"     isActive={activeButton === "best_selling"}      onClick={sortBestSelling} />
        <SortButton label="Maiores Descontos" isActive={activeButton === "biggest_discounts"} onClick={sortBiggestDiscounts} />
        <SortButton label="Menores Preços"    isActive={activeButton === "lowest_prices"}     onClick={sortLowestPrices} />
      </Box>

      <Box mb="20px" h="1px" bg="rgba(0,74,51,.08)" />

      <SectionLabel>Faixa de Preço</SectionLabel>
      <Box display="flex" gap="10px" mb="24px">
        <Box flex={1}>
          <Text fontSize="11px" fontWeight="700" color="rgba(0,74,51,0.5)" mb="5px">Mínimo</Text>
          <Input
            placeholder="R$ 0"
            h="38px"
            bg="white"
            borderRadius="10px"
            border="1.5px solid rgba(0,74,51,0.15)"
            fontSize="13px"
            fontWeight="600"
            color="#004a33"
            _focus={{ borderColor: "#004a33", boxShadow: "0 0 0 3px rgba(0,74,51,0.1)" }}
            _placeholder={{ color: "rgba(0,74,51,0.3)" }}
            onChange={handleMinPriceChange}
          />
        </Box>
        <Box flex={1}>
          <Text fontSize="11px" fontWeight="700" color="rgba(0,74,51,0.5)" mb="5px">Máximo</Text>
          <Input
            placeholder="R$ 999"
            h="38px"
            bg="white"
            borderRadius="10px"
            border="1.5px solid rgba(0,74,51,0.15)"
            fontSize="13px"
            fontWeight="600"
            color="#004a33"
            _focus={{ borderColor: "#004a33", boxShadow: "0 0 0 3px rgba(0,74,51,0.1)" }}
            _placeholder={{ color: "rgba(0,74,51,0.3)" }}
            onChange={handleMaxPriceChange}
          />
        </Box>
      </Box>

      <Box mb="20px" h="1px" bg="rgba(0,74,51,.08)" />

      {handleFilterToDisplay()}
    </>
  );

  return (
    <Box
      bg="white"
      borderRadius="24px"
      border="1px solid rgba(0,74,51,.08)"
      boxShadow="0 12px 35px rgba(0,74,51,.08)"
      h="100%"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      width="100%"
    >
      {/* HEADER FIXO */}
      <Box
        bg={`linear-gradient(
          135deg,
          ${theme.colors.primaryGreen} 0%,
          #006646 100%
        )`}
        px="24px"
        py="18px"
        flexShrink={0}
      >
        <Text
          color={theme.colors.primaryOrange}
          fontSize="22px"
          fontWeight="900"
        >
          Filtros
        </Text>
      </Box>

      {/* MOBILE */}
      <Box display={{ base: "block", xl: "none" }}>
        <Accordion allowToggle>
          <AccordionItem border="none">
            <AccordionButton
              py="16px"
              px="20px"
              bg="#FAFAFA"
              fontWeight="800"
              color={theme.colors.primaryGreen}
            >
              <Box flex="1" textAlign="left">
                FILTRAR
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel p="20px">
              {renderFiltersContent()}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Box>

      {/* DESKTOP */}
      <Box
        display={{ base: "none", xl: "block" }}
        flex="1"
        minH="0"
        overflowY="auto"
        overflowX="hidden"
        p="20px"
        css={{
          "&::-webkit-scrollbar": {
            width: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.colors.primaryGreen,
            borderRadius: "999px",
          },
        }}
      >
        {renderFiltersContent()}
      </Box>
    </Box>
  );


}
